import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { managementPage } from '../../data/mock';
import { Users, ChevronRight } from 'lucide-react';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Footer from '../../components/layout/Footer';

const Management = () => {
  const { language } = useLanguage();
  const content = managementPage[language];

  return (
    <div className="min-h-screen relative">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&q=80')`,
        }}
      >
        <div className="absolute inset-0 bg-[#1a2a3a]/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center px-4 sm:px-6 pt-24 sm:pt-32 pb-20 sm:pb-24">
        <AnimateOnScroll animation="fadeIn">
          <div className="mb-6 sm:mb-8">
            <Users className="text-[#3eb8b3]" size={48} strokeWidth={1} />
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeInUp" delay={100}>
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-light mb-6 sm:mb-8 text-center">
            {content.title}
          </h1>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeInUp" delay={200}>
          <p className="text-white/80 text-base sm:text-xl text-center max-w-3xl mb-8 sm:mb-12 leading-relaxed">
            {content.intro}
          </p>
        </AnimateOnScroll>

        <div className="max-w-4xl w-full space-y-4 sm:space-y-6 mb-12 sm:mb-16">
          {content.points.map((point, index) => (
            <AnimateOnScroll key={index} animation="fadeInUp" delay={300 + index * 100}>
              <div className="flex items-start gap-3 sm:gap-4 text-white/80 text-base sm:text-lg leading-relaxed">
                <ChevronRight className="text-[#3eb8b3] shrink-0 mt-1" size={18} />
                <p>{point}</p>
              </div>
            </AnimateOnScroll>
          ))}
        </div>

        {/* Process diagram */}
        <AnimateOnScroll animation="scaleIn" delay={400} className="max-w-4xl w-full mb-8 sm:mb-12">
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-4 sm:p-8 border border-white/10">
            <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
              {[
                language === 'es' ? 'Análisis' : 'Analysis',
                language === 'es' ? 'Negociación' : 'Negotiation',
                language === 'es' ? 'Gestión' : 'Management',
                language === 'es' ? 'Comercialización' : 'Marketing',
                language === 'es' ? 'Reporting' : 'Reporting',
              ].map((step, i) => (
                <React.Fragment key={i}>
                  <div className="bg-[#3eb8b3]/20 border border-[#3eb8b3] px-3 sm:px-6 py-2 sm:py-3 rounded">
                    <span className="text-white text-sm sm:text-base">{step}</span>
                  </div>
                  {i < 4 && (
                    <ChevronRight className="text-[#3eb8b3] hidden md:block" size={20} />
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </AnimateOnScroll>

        <Link
          to="/contacto"
          className="hover-glow bg-[#3eb8b3] text-white px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg tracking-wider hover:bg-[#2ea09b] transition-colors"
        >
          {content.cta}
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default Management;
